import { Inject, inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpStatusCode } from '@angular/common/http';
import { catchError, from, Observable, switchMap, throwError } from 'rxjs';
import { AUTH_SERVICE } from './auth.token';
import { IAuthService } from './auth.types';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(
        @Inject(AUTH_SERVICE) private authService: IAuthService
    ) {

    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return from(this.autoRenewAccessTokenIfExpiring())
            .pipe(
                switchMap(_ => {
                    const authToken = this.authService.getAuthorizationToken();
                    const clientName = this.extractClientNameFromTheUrl();
                    const authReq = request.clone({
                        headers: request.headers.
                            set('Authorization', authToken)
                            .set('X-Client', clientName)
                    });

                    return next.handle(authReq)
                        .pipe(
                            catchError(err => {
                                if (err.status === HttpStatusCode.Unauthorized) {
                                    const { href, origin } = location;
                                    this.authService.signIn(href.replace(origin, ''));
                                }

                                return throwError(err);
                            })
                        );
                })
            );
    }

    private async autoRenewAccessTokenIfExpiring(): Promise<void> {
        try {
            if (this.authService.isReady && this.authService.isAccessTokenExpiring()) {
                await this.authService.signinSilent();
            }
        } catch (err) {
            console.error('Failed to renew session silently.', err);
        }
    }

    private extractClientNameFromTheUrl(): string {
        const segments = window.location.pathname.split('/').filter(Boolean);
        return segments.length > 0 ? segments[0] : 'client1';
    }
}
